







import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DropZone from '@/components/Views/UI/DropZone.vue';
import {nil} from '@/common';
import axios, {AxiosRequestConfig} from 'axios';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import ImageGrid from '@/components/Views/UI/ImageGrid.vue';
import {FeathersVuexFindAll} from '@/utils';
import ImageGrid2 from '@/components/Views/UI/ImageGrid2.vue';
import {pickBy} from 'lodash';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';

@Component({
    components: {
        GenericDialog,
        ImageGrid2,
    },
})
export default class SelectImportedFilesDialog extends Mixins(GlobalAlertMixin) {

    public open = false;
    public uploadedImages = [];

    @Prop({default: () => []})
    public value!: string[];

    public selection!: any;

    @Prop({default: false})
    public multiple!: boolean;

    @Prop({default: ''})
    public importType!: string;

    @Prop({default: ''})
    public title!: string;

    @Prop(Function)
    public params!: () => any;

    @Prop({default: ''})
    public purpose!: string;

    @Prop({default: true})
    public limitToUser!: boolean;

    @Prop({default: false})
    public inline!: boolean;

    @Prop({default: false})
    public deletable!: boolean;

    @Prop({default: true})
    public selectable!: boolean;

    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (value) { this.loadExistingImages(); }
    }
    public mounted() {
        this.loadExistingImages(true);
    }

    public get allImages() {
        const result = {};
        for (const i of this.uploadedImages) {
            if (nil(this.value[i])) {
                result[i] = false;
            } else {
                result[i] = this.value[i];
            }
        }
        return result;
    }
    public set allImages(value) {
        this.$emit('input', pickBy(value, (x) => x));
        this.$emit('onChange');
        if (Object.keys(value).length !== Object.keys(this.allImages).length) {
            this.loadExistingImages();
        }
    }
    public async loadExistingImages(firstLoad = false) {
        const {Upload} = this.$FeathersVuex;
        const userQuery = this.limitToUser ? {user: this.$store.state.auth.user._id} : {};
        const purposeQuery = !nil(this.purpose, true) ? {purpose: this.purpose} : {};
        const fullQuery = {
            ...userQuery,
            ...purposeQuery,
        };
        const images = await FeathersVuexFindAll(Upload, {query: fullQuery});
        this.uploadedImages = images.map((x) => x._id);
    }
    public cancelClicked() {
        this.open = false;
    }
}
